var exports = {
  "VQ": "TabBar__ehyf67",
  "tU": "Tabs__H-kvAF",
  "dT": "LeadingAction__cVtWIH",
  "j": "TabContainer__xaBHch",
  "oz": "Tab__m-hVDo",
  "zr": "activeTabContainer__rrhX2k",
  "Qe": "activeTab__TxJ4d2",
  "yP": "TabLabel__0rPhXQ",
  "Pe": "closableTab__PHEDN4",
  "En": "TabCloseButton__n_4R8E",
  "yE": "TrailingActions__IBHaCp",
  "lA": "MeasureRow__wlz8SP",
};

module.exports = exports;
